export const OPERATE_COMPONENT_TYPE = {
    WEBVIEW: 1,
    PLAYER_VIEW: 2,
    STORE_KIT_VIEW: 3,
    SUBPLAY_TEMPLATE_VIEW: 4,
    END_CARD: 5,
    OM: 6
}